import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import store from 'redux/store';
import { APP_INITIALIZE_REQUESTED } from 'redux/constants/app.constants';
import history from 'helpers/history';
import 'App.scss';
import 'react-notifications/lib/notifications.css';
import ScriptContainer from 'containers/ScriptContainer';
import { getDomainName } from 'helpers/url';
import SiteShellContainer from 'containers/SiteShellContainer';
import { captureSellerReferral } from 'helpers/referral';

if (typeof window !== 'undefined') captureSellerReferral();

const App = () => {

  const todayYmd = () => {
    const d = new Date();
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  };

  function getCookie(name) {
    const all = `; ${document.cookie}`;
    const parts = all.split(`; ${encodeURIComponent(name)}=`);
    if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
    return null;
  }

  function setCookie(name, value, opts = {}) {
    const MaxAge = opts.maxAge ?? 86400;
    const Path = opts.path ?? '/';
    const SameSite = opts.sameSite ?? 'Lax';
    const Secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = 
      `${encodeURIComponent(name)}=${encodeURIComponent(value)}; ` +
      `Path=${Path}; SameSite=${SameSite}; Max-Age=${MaxAge}${Secure}`;
  }

  useEffect(() => {
    if (window.__APP_INIT_DONE__) return;
    window.__APP_INIT_DONE__ = true;

    const date = todayYmd();
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const params = new URLSearchParams(window.location.search);
    const platform = String(params.get('platform') ?? '0');
    const client_id = process.env.REACT_APP_CLIENT_ID || '';
    const key = `_plat_v1__${client_id}_${platform}`;
    
    const cookieVal = getCookie(key);
    const shouldRegisterVisit = cookieVal !== date;

    if (shouldRegisterVisit) {
      setCookie(key, date, { maxAge: 86400, path: '/', sameSite: 'Lax' });
      localStorage.setItem(key, date);
    }

    const visit = shouldRegisterVisit ? { date, platform, isMobile } : null;

    const urls = getDomainName();
    console.log(urls);
    store.dispatch({ type: APP_INITIALIZE_REQUESTED, payload: {visit} });
  }, []);

  return (
    <Provider store={store}>
      <ScriptContainer />
      <Router history={history}>
        <SiteShellContainer />
      </Router>
    </Provider>
  );
};

export default App;
